import { isFunction } from 'ramda-adjunct';

export const callOrUse = (maybeFn, ...args) => (isFunction(maybeFn) ? maybeFn(...args) : maybeFn);
